<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add New User') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          autocomplete="chrome-off"
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!-- Firma ad -->
          <b-form-group
            :label="$t('Firma')"
            label-for="customer_id"
          >
            <vue-autosuggest
              :suggestions="customerSuggest.filteredCustomers"
              :input-props="customerSuggest.inputProps"
              :value="customer_name"
              @selected="customerSelected"
              @input="customerOnInputChanged"
            >
              <template slot-scope="{suggestion}">
                <div class="d-flex align-items-center">

                  <div class="detail ml-50">
                    <b-card-text class="mb-0">
                      {{ suggestion.item.name }}
                    </b-card-text>
                    <small class="text-muted">
                      {{ suggestion.item.id }}
                    </small>
                  </div>
                </div>
              </template>
            </vue-autosuggest>

          </b-form-group>
          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="Full Name"
            rules="required|min:2"
          >
            <b-form-group
              label="Ad"
              label-for="full-name_KD1"
            >
              <b-form-input
                id="full-name_KD"
                v-model="userData.name"
                autocomplete="chrome-off"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Surname"
            rules="required"
          >
            <b-form-group
              label="Soyad"
              label-for="surname_KD"
            >
              <b-form-input
                id="surnam_KDe"
                v-model="userData.surname"
                autocomplete="chrome-off"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required|email"
          >
            <b-form-group
              label="Email"
              label-for="email_KD"
            >
              <b-form-input
                id="email_KD"
                v-model="userData.email"
                autocomplete="chrome-off"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- password field -->

          <validation-provider
            #default="{ errors }"
            name="Password"
            vid="password"
            rules="required"
          >
            <b-form-group
              label-for="password_KD"
              label="Şifre"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid':null"
              >
                <b-form-input
                  id="password_KD"
                  v-model="userData.password"
                  class="form-control-merge"
                  autocomplete="chrome-off"
                  :state="errors.length > 0 ? false:null"

                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ $t('Kaydet') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t('Vazgeç') }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BCardText,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import router from '@/router'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  components: {
    BSidebar,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    VueAutosuggest,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
    customerObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,

      customerSuggest: {
        limit: 10,
        filteredCustomers: [],
        inputProps: {
          id: 'customer_id',
          class: 'form-control',
          placeholder: 'Firma Adı Giriniz',

        },

      },
    }
  },
  watch: {
    customerObj(val) {
      if (val != null) {
        this.userData.company_id = this.customerObj.id
        this.customer_name = this.customerObj.name
      }
    },
  },
  created() {
    if (this.customerObj != null) {
      this.userData.company_id = this.customerObj.id
      this.customer_name = this.customerObj.name
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    customerSelected(option) {
      this.userData.company_id = option.item.id
    },
    customerOnInputChanged(text) {
      if (text === '' || text === undefined) {
        return
      }
      store.dispatch('app/suggestCustomers', { name: text, limit: this.customerSuggest.limit, list_for: 'order' })
        .then(response => {
          this.customerSuggest.filteredCustomers = [{
            data: response.data.data,
          }]
        })
    },
  },
  setup(props, { emit }) {
    const blankUserData = ref({
      name: '',
      surname: '',
      email: '',
      password: '',
      company_id: 0,
    })
    // eslint-disable-next-line camelcase
    const customer_name = ref('')

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }

    const onSubmit = () => {
      store.dispatch('app-user/addUser', userData.value)
        .then(response => {
          emit('update:is-add-new-user-sidebar-active', false)
          router.push({ name: 'users-edit', params: { id: response.data.data.id } })
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
      customer_name,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
